// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file mapbox/geobuf/v1/geobuf.proto (package mapbox.geobuf.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum mapbox.geobuf.v1.Type
 */
export enum Type {
  /**
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * @generated from enum value: POINT = 0;
   */
  POINT = 0,

  /**
   * buf:lint:ignore ENUM_VALUE_PREFIX
   *
   * @generated from enum value: MULTIPOINT = 1;
   */
  MULTIPOINT = 1,

  /**
   * buf:lint:ignore ENUM_VALUE_PREFIX
   *
   * @generated from enum value: LINESTRING = 2;
   */
  LINESTRING = 2,

  /**
   * buf:lint:ignore ENUM_VALUE_PREFIX
   *
   * @generated from enum value: MULTILINESTRING = 3;
   */
  MULTILINESTRING = 3,

  /**
   * buf:lint:ignore ENUM_VALUE_PREFIX
   *
   * @generated from enum value: POLYGON = 4;
   */
  POLYGON = 4,

  /**
   * buf:lint:ignore ENUM_VALUE_PREFIX
   *
   * @generated from enum value: MULTIPOLYGON = 5;
   */
  MULTIPOLYGON = 5,

  /**
   * buf:lint:ignore ENUM_VALUE_PREFIX
   *
   * @generated from enum value: GEOMETRYCOLLECTION = 6;
   */
  GEOMETRYCOLLECTION = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(Type)
proto3.util.setEnumType(Type, "mapbox.geobuf.v1.Type", [
  { no: 0, name: "POINT" },
  { no: 1, name: "MULTIPOINT" },
  { no: 2, name: "LINESTRING" },
  { no: 3, name: "MULTILINESTRING" },
  { no: 4, name: "POLYGON" },
  { no: 5, name: "MULTIPOLYGON" },
  { no: 6, name: "GEOMETRYCOLLECTION" },
]);

/**
 * @generated from message mapbox.geobuf.v1.FeatureCollection
 */
export class FeatureCollection extends Message<FeatureCollection> {
  /**
   * @generated from field: repeated mapbox.geobuf.v1.Feature features = 1;
   */
  features: Feature[] = [];

  /**
   * @generated from field: repeated mapbox.geobuf.v1.Value values = 13;
   */
  values: Value[] = [];

  /**
   * @generated from field: repeated uint32 custom_properties = 15 [packed = true];
   */
  customProperties: number[] = [];

  constructor(data?: PartialMessage<FeatureCollection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mapbox.geobuf.v1.FeatureCollection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "features", kind: "message", T: Feature, repeated: true },
    { no: 13, name: "values", kind: "message", T: Value, repeated: true },
    { no: 15, name: "custom_properties", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FeatureCollection {
    return new FeatureCollection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FeatureCollection {
    return new FeatureCollection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FeatureCollection {
    return new FeatureCollection().fromJsonString(jsonString, options);
  }

  static equals(a: FeatureCollection | PlainMessage<FeatureCollection> | undefined, b: FeatureCollection | PlainMessage<FeatureCollection> | undefined): boolean {
    return proto3.util.equals(FeatureCollection, a, b);
  }
}

/**
 * @generated from message mapbox.geobuf.v1.Feature
 */
export class Feature extends Message<Feature> {
  /**
   * @generated from field: mapbox.geobuf.v1.Geometry geometry = 1;
   */
  geometry?: Geometry;

  /**
   * @generated from oneof mapbox.geobuf.v1.Feature.id_type
   */
  idType: {
    /**
     * @generated from field: string id = 11;
     */
    value: string;
    case: "id";
  } | {
    /**
     * @generated from field: sint64 int_id = 12;
     */
    value: bigint;
    case: "intId";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * unique values
   *
   * @generated from field: repeated mapbox.geobuf.v1.Value values = 13;
   */
  values: Value[] = [];

  /**
   * pairs of key/value indexes
   *
   * @generated from field: repeated uint32 properties = 14 [packed = true];
   */
  properties: number[] = [];

  /**
   * arbitrary properties
   *
   * @generated from field: repeated uint32 custom_properties = 15 [packed = true];
   */
  customProperties: number[] = [];

  constructor(data?: PartialMessage<Feature>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mapbox.geobuf.v1.Feature";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "geometry", kind: "message", T: Geometry },
    { no: 11, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "id_type" },
    { no: 12, name: "int_id", kind: "scalar", T: 18 /* ScalarType.SINT64 */, oneof: "id_type" },
    { no: 13, name: "values", kind: "message", T: Value, repeated: true },
    { no: 14, name: "properties", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 15, name: "custom_properties", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Feature {
    return new Feature().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Feature {
    return new Feature().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Feature {
    return new Feature().fromJsonString(jsonString, options);
  }

  static equals(a: Feature | PlainMessage<Feature> | undefined, b: Feature | PlainMessage<Feature> | undefined): boolean {
    return proto3.util.equals(Feature, a, b);
  }
}

/**
 * @generated from message mapbox.geobuf.v1.Geometry
 */
export class Geometry extends Message<Geometry> {
  /**
   * @generated from field: mapbox.geobuf.v1.Type type = 1;
   */
  type = Type.POINT;

  /**
   * coordinate structure in lengths
   *
   * @generated from field: repeated uint32 lengths = 2 [packed = true];
   */
  lengths: number[] = [];

  /**
   * delta-encoded integer values
   *
   * @generated from field: repeated sint64 coords = 3 [packed = true];
   */
  coords: bigint[] = [];

  /**
   * @generated from field: repeated mapbox.geobuf.v1.Geometry geometries = 4;
   */
  geometries: Geometry[] = [];

  /**
   * @generated from field: repeated mapbox.geobuf.v1.Value values = 13;
   */
  values: Value[] = [];

  /**
   * @generated from field: repeated uint32 custom_properties = 15 [packed = true];
   */
  customProperties: number[] = [];

  constructor(data?: PartialMessage<Geometry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mapbox.geobuf.v1.Geometry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(Type) },
    { no: 2, name: "lengths", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 3, name: "coords", kind: "scalar", T: 18 /* ScalarType.SINT64 */, repeated: true },
    { no: 4, name: "geometries", kind: "message", T: Geometry, repeated: true },
    { no: 13, name: "values", kind: "message", T: Value, repeated: true },
    { no: 15, name: "custom_properties", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Geometry {
    return new Geometry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Geometry {
    return new Geometry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Geometry {
    return new Geometry().fromJsonString(jsonString, options);
  }

  static equals(a: Geometry | PlainMessage<Geometry> | undefined, b: Geometry | PlainMessage<Geometry> | undefined): boolean {
    return proto3.util.equals(Geometry, a, b);
  }
}

/**
 * @generated from message mapbox.geobuf.v1.Value
 */
export class Value extends Message<Value> {
  /**
   * @generated from oneof mapbox.geobuf.v1.Value.value_type
   */
  valueType: {
    /**
     * @generated from field: string string_value = 1;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: double double_value = 2;
     */
    value: number;
    case: "doubleValue";
  } | {
    /**
     * @generated from field: uint64 pos_int_value = 3;
     */
    value: bigint;
    case: "posIntValue";
  } | {
    /**
     * @generated from field: uint64 neg_int_value = 4;
     */
    value: bigint;
    case: "negIntValue";
  } | {
    /**
     * @generated from field: bool bool_value = 5;
     */
    value: boolean;
    case: "boolValue";
  } | {
    /**
     * @generated from field: string json_value = 6;
     */
    value: string;
    case: "jsonValue";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Value>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mapbox.geobuf.v1.Value";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "string_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value_type" },
    { no: 2, name: "double_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "value_type" },
    { no: 3, name: "pos_int_value", kind: "scalar", T: 4 /* ScalarType.UINT64 */, oneof: "value_type" },
    { no: 4, name: "neg_int_value", kind: "scalar", T: 4 /* ScalarType.UINT64 */, oneof: "value_type" },
    { no: 5, name: "bool_value", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "value_type" },
    { no: 6, name: "json_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value_type" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Value {
    return new Value().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Value {
    return new Value().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Value {
    return new Value().fromJsonString(jsonString, options);
  }

  static equals(a: Value | PlainMessage<Value> | undefined, b: Value | PlainMessage<Value> | undefined): boolean {
    return proto3.util.equals(Value, a, b);
  }
}

/**
 * @generated from message mapbox.geobuf.v1.Data
 */
export class Data extends Message<Data> {
  /**
   * global arrays of unique keys
   *
   * @generated from field: repeated string keys = 1;
   */
  keys: string[] = [];

  /**
   * max coordinate dimensions
   *
   * @generated from field: optional uint32 dimensions = 2;
   */
  dimensions?: number;

  /**
   * number of digits after decimal point for coordinates
   *
   * @generated from field: optional uint32 precision = 3;
   */
  precision?: number;

  /**
   * @generated from oneof mapbox.geobuf.v1.Data.data_type
   */
  dataType: {
    /**
     * @generated from field: mapbox.geobuf.v1.FeatureCollection feature_collection = 4;
     */
    value: FeatureCollection;
    case: "featureCollection";
  } | {
    /**
     * @generated from field: mapbox.geobuf.v1.Feature feature = 5;
     */
    value: Feature;
    case: "feature";
  } | {
    /**
     * @generated from field: mapbox.geobuf.v1.Geometry geometry = 6;
     */
    value: Geometry;
    case: "geometry";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Data>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mapbox.geobuf.v1.Data";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "dimensions", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 3, name: "precision", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 4, name: "feature_collection", kind: "message", T: FeatureCollection, oneof: "data_type" },
    { no: 5, name: "feature", kind: "message", T: Feature, oneof: "data_type" },
    { no: 6, name: "geometry", kind: "message", T: Geometry, oneof: "data_type" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Data {
    return new Data().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Data {
    return new Data().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Data {
    return new Data().fromJsonString(jsonString, options);
  }

  static equals(a: Data | PlainMessage<Data> | undefined, b: Data | PlainMessage<Data> | undefined): boolean {
    return proto3.util.equals(Data, a, b);
  }
}

